import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTotalClients = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.8891 19.002V17.2242C19.8891 15.5674 18.756 14.1753 17.2224 13.7806M14.1113 3.26041C15.4144 3.78786 16.3335 5.06534 16.3335 6.55751C16.3335 8.04968 15.4144 9.32716 14.1113 9.85461M15.4447 19.002C15.4447 17.3453 15.4447 16.5169 15.174 15.8635C14.8131 14.9923 14.121 14.3001 13.2498 13.9393C12.5963 13.6686 11.768 13.6686 10.1113 13.6686H7.44466C5.78798 13.6686 4.95964 13.6686 4.30623 13.9393C3.43502 14.3001 2.74285 14.9923 2.38198 15.8635C2.11133 16.5169 2.11133 17.3453 2.11133 19.002M12.3335 6.55751C12.3335 8.52119 10.7417 10.1131 8.77799 10.1131C6.81432 10.1131 5.22244 8.52119 5.22244 6.55751C5.22244 4.59383 6.81432 3.00195 8.77799 3.00195C10.7417 3.00195 12.3335 4.59383 12.3335 6.55751Z",
		stroke: "black",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTotalClients;
